<script lang="ts">
	import IconButton from '../buttons/IconButton.svelte';
	import { _ } from 'svelte-i18n';

	let theme = localStorage.theme;

	function switchTheme(newTheme: string) {
		if (newTheme === 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}

		localStorage.theme = newTheme;
		theme = newTheme;
	}
</script>

<div>
	{#if theme === 'dark'}
		<IconButton
			showCircle={false}
			hoverText={$_('header.bt_dark')}
			iconName="moon"
			onClick={() => {
				switchTheme('light');
			}}
		></IconButton>
	{:else}
		<IconButton
			showCircle={false}
			iconName="sun"
			hoverText={$_('header.bt_light')}
			onClick={() => {
				switchTheme('dark');
			}}
		></IconButton>
	{/if}
</div>
